import type { IWeightFormatter } from "@common/helpers/WeightFormatter";
import { ArrowLeftRight } from "lucide-react";

import { Button } from "components/core/Button";
import { Flex } from "components/core/Flex";
import LucideIcon from "components/core/Icon/LucideIcon";
import { NumberInput } from "components/core/NumberInput";
import { Text } from "components/core/Text";

import { maxHarvestAmount } from "./harvestAmount";

type Props = {
  amount: number | null;
  unit: string;
  formatter: IWeightFormatter;
  onAmountChange: (value: number | null) => void;
  onToggleUnit: () => void;
  disabled?: boolean;
  invalid?: boolean;
};

const HarvestAmountField = ({
  amount,
  unit,
  formatter,
  onAmountChange,
  onToggleUnit,
  disabled,
  invalid
}: Props) => (
  <div>
    <Flex align="center" gap={1}>
      <Text variant="bodySmall" weight="semibold">
        Amount
      </Text>
      <Button disabled={disabled} size="small" variant="text" onClick={onToggleUnit}>
        ({unit})
        <LucideIcon color="currentColor" glyph={ArrowLeftRight} size="small" />
      </Button>
    </Flex>
    <NumberInput
      aria-invalid={invalid}
      aria-label="Amount"
      max={maxHarvestAmount(formatter, unit)}
      min={0.01}
      placeholder={`Enter amount in ${unit}`}
      step={0.1}
      stepButtons={false}
      value={amount}
      onChange={onAmountChange}
    />
  </div>
);

export default HarvestAmountField;
